import { NgModule } from '@angular/core';
import { ContainerSizeDirective } from './container-size.directive';

@NgModule({
  declarations: [ContainerSizeDirective],
  exports: [ContainerSizeDirective],
})
export class ContainerSizeModule {}
